import * as types from "../types";


export const createAuctionRequest = ({accessToken,auction_name,start_date,end_date,file,auction_group}) => ({
    type: types.CREATE_AUCTION_REQUEST,
    payload:{
        accessToken,auction_name,start_date,end_date,file,auction_group
    }
})

export const createAuctionSuccess = ({createAuctionResult}) => ({
    type: types.CREATE_AUCTION_SUCCESS,
    payload:{
        createAuctionResult
    }
})

export const createAuctionFailure = ({error}) => ({
    type: types.CREATE_AUCTION_FAILURE,
    payload:{
        error: error.message
    }
})

export const createAuctionReset = () => ({
    type: types.CREATE_AUCTION_RESET,
})

